import { Component, Input } from '@angular/core';
import { Select } from '@ngxs/store';
import { Locations, Performance } from 'county-api';
import { Observable } from 'rxjs';
import { LocationsState } from '../../../../locations/store/locations.state';

@Component({
    selector: 'revenue-leaderboard',
    templateUrl: './revenue-leaderboard.component.html',
    styleUrls: ['./revenue-leaderboard.component.scss'],
})
export class RevenueLeaderboardComponent {
    @Select(LocationsState.locationsMap)
    locations$: Observable<{ [key: number]: Locations.ILocation }>;

    @Input()
    performanceData: Performance.IPerformanceMonthly[];
}
